import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';

import errorBoundary from '@ifeng-fe/errorBoundary';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Chip from 'Chip';
import Slides from '@ifeng-fe/ui_pc_slides';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { addEventListener, Event } from '@ifeng-fe/ui_base';
import { getCommentCount, getNewInfoIndexList, getInfoDataList, getMoneyStream } from '../../../../services/api';

const { formatImage } = require('@ifeng-fe/public_method');

/**
 * 定义 Footer 组件
 */
class TabInfo extends React.PureComponent {
    // static propTypes = {
    //     content: PropTypes.object,
    //     // event: PropTypes.object,
    // };
    state = {
        current: 0,
        isFixed: false,
        len: 25,
        lenHot: 25,
        lenBank: 25,
        lenInsure: 25,
        lenFund: 25,
        dataHot: [],
        dataBank: [],
        dataInsure: [],
        dataFund: [],
        hotCount: [],
        bankCount: [],
        insureCount: [],
        fundCount: [],
    };
    event = new Event();
    async componentDidMount() {
        // console.log('content==', this.props.content);
        this.unHandleScroll = addEventListener(window, 'scroll', this.handleScroll);
        // const { hotStreamF, bankStreamF, insureStreamF, fundStreamF } = this.props.content;

        const dataHot = await getMoneyStream('1-73-47-', '0', this.state.len);
        const dataBank = await getMoneyStream('1-73-215395-', '0', this.state.len);
        const dataInsure = await getMoneyStream('1-73-245402-', '0', this.state.len);
        const dataFund = await getMoneyStream('1-73-245403-', '0', this.state.len);
        // console.log('data===', dataHot.data);
        // eslint-disable-next-line one-var
        let dataHotF = [],
            dataBankF = [],
            dataInsureF = [],
            dataFundF = [];

        // dataHot = dataHot ? dataHot : [];
        if (dataHot.code === 0 && dataHot.data && dataHot.data.map) {
            dataHotF = this.formatStream(dataHot.data);
        }
        if (dataBank.code === 0 && dataBank.data && dataBank.data.map) {
            dataBankF = this.formatStream(dataBank.data);
        }
        if (dataInsure.code === 0 && dataInsure.data && dataInsure.data.map) {
            dataInsureF = this.formatStream(dataInsure.data);
        }
        if (dataFund.code === 0 && dataFund.data && dataFund.data.map) {
            dataFundF = this.formatStream(dataFund.data);
        }

        this.getCommentInfo(dataHotF).then(value =>
            this.setState({
                hotCount: value,
            }),
        );
        this.getCommentInfo(dataBankF).then(value =>
            this.setState({
                bankCount: value,
            }),
        );
        this.getCommentInfo(dataInsureF).then(value =>
            this.setState({
                insureCount: value,
            }),
        );
        this.getCommentInfo(dataFundF).then(value =>
            this.setState({
                fundCount: value,
            }),
        );

        this.setState({
            dataHot: dataHotF,
            dataBank: dataBankF,
            dataInsure: dataInsureF,
            dataFund: dataFundF,
            // hotCount: countHot,
            // bankCount: countBank,
            // insureCount: countInsure,
            // fundCount: countFund,
        });
    }

    componentWillUnmount() {
        this.unHandleScroll();
    }
    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = dom => {
        let offsetTop = dom.offsetTop;

        if (dom.offsetParent) {
            offsetTop += this.getOffsetTop(dom.offsetParent);
        }

        return offsetTop;
    };
    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        const offsetTop = this.getOffsetTop(document.getElementById('tabs'));

        this.tabsTop = document.getElementById('tabs').offsetTop || offsetTop;

        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (currentTop > this.tabsTop) {
            this.setState({ isFixed: true });
        } else {
            this.setState({ isFixed: false });
        }
    };

    /**
     * tab点击切换
     */
    handleClick = index => {
        scrollTo(0, this.tabsTop);

        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 加载更多渲染
     */
    moreView = (data, len, key) => {
        // console.log('len===', len);
        if (data.length < len) {
            return <div className={styles.all}>已显示全部</div>;
        } else {
            return (
                <div className={styles.more} onClick={() => this.getMore(key)}>
                    查看更多
                </div>
            );
        }
    };

    /**
     * 信息流渲染
     */
    listView = (data, len, count) => {
        // console.log('data===', data);
        if (data.length > 0) {
            return data.map((item, index) => (
                <div key={index} className={styles.list}>
                    {item.src && item.src !== '' ? (
                        <a href={item.url} target="_blank" rel={rel} className={styles.imgBox} data-innermask>
                            <LazyImg src={item.src} width="144" height="96" className={styles.trans} />
                        </a>
                    ) : (
                        ''
                    )}
                    <div className={styles.list_text}>
                        <p className={styles.text}>
                            <a href={item.url} target="_blank" rel={rel} title={item.title} data-innermask>
                                {item.title}
                            </a>
                        </p>
                        <p className={styles.time}>
                            {item.source ? <span className={styles.source}>{item.source}</span> : ''}
                            {item.newsTime && item.newsTime !== '' ? (
                                <span className={styles.date}>{item.newsTime}</span>
                            ) : (
                                ''
                            )}
                        </p>
                    </div>
                    {count && count.length > 0 && count[index] > 0 ? (
                        <div className={styles.comment}>
                            <a
                                href={`//gentie.ifeng.com/view.html?docUrl=${item.commentUrl}&docName=${
                                    item.title
                                }&skey=${item.skey}&pcUrl&=${item.pcUrl}`}
                                target="_blank"
                                rel={rel}
                                data-innermask>
                                {count[index]}
                            </a>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            ));
        } else {
            // 未取到数据
        }
    };
    /**
     * 获取更多新闻
     */
    getMore = async key => {
        if (key === '1-73-47-') {
            const { lenHot, dataHot } = this.state;
            const data = await getMoneyStream(key, lenHot, '5');
            const dataF = this.formatStream(data.data);
            const len = lenHot + 5;
            const dataNew = dataHot.concat(dataF);

            // const dUrl = dataNew.map(item => item.commentUrl);
            // const Counts = await getCommentCount(dUrl);
            // const count = Counts.map(item => item.count);
            this.getCommentInfo(dataNew).then(value =>
                this.setState({
                    hotCount: value,
                }),
            );

            // console.log('data,count==', dataNew, count);
            this.setState({
                lenHot: len,
                dataHot: dataNew,
                // hotCount: count,
            });
        } else if (key === '1-73-215395-') {
            const { lenBank, dataBank } = this.state;
            const data = await getMoneyStream(key, lenBank, '5');
            const dataF = this.formatStream(data.data);
            const len = lenBank + 5;
            const dataNew = dataBank.concat(dataF);

            this.getCommentInfo(dataNew).then(value =>
                this.setState({
                    bankCount: value,
                }),
            );

            // console.log('data,count==', dataNew, count);
            this.setState({
                lenBank: len,
                dataBank: dataNew,
            });
        } else if (key === '1-73-245402-') {
            const { lenInsure, dataInsure } = this.state;
            const data = await getMoneyStream(key, lenInsure, '5');
            const dataF = this.formatStream(data.data);
            const len = lenInsure + 5;
            const dataNew = dataInsure.concat(dataF);

            this.getCommentInfo(dataNew).then(value =>
                this.setState({
                    insureCount: value,
                }),
            );

            // console.log('data,count==', dataNew, count);
            this.setState({
                lenInsure: len,
                dataInsure: dataNew,
            });
        } else if (key === '1-73-245403-') {
            const { lenFund, dataFund } = this.state;
            const data = await getMoneyStream(key, lenFund, '5');
            const dataF = this.formatStream(data.data);
            const dataNew = dataFund.concat(dataF);
            const len = lenFund + 5;

            this.getCommentInfo(dataNew).then(value =>
                this.setState({
                    fundCount: value,
                }),
            );

            // console.log('data,count==', dataNew, count);
            this.setState({
                lenFund: len,
                dataFund: dataNew,
            });
        }
    };

    /**
     * 格式化信息流数据
     */
    formatStream = data => {
        const dataF = data.map(item => ({
            title: item.title,
            src: item.src ? formatImage(item.src, 144, 96) : '',
            url: item.url,
            source: item.source,
            newsTime: item.newsTime,
            commentUrl: item.commentUrl,
        }));

        return dataF;
    };
    /**
     * 获取评论数
     */
    getCommentInfo = async data => {
        const dataUrl = data.map(item => item.commentUrl);
        const Counts = await getCommentCount(dataUrl);
        const count = Counts.map(item => item.count);

        return count;
    };
    /**
     * 渲染组件
     */
    render() {
        // const { content } = this.props;
        // const { hotStreamF, bankStreamF, insureStreamF, fundStreamF } = this.props.content;
        const {
            isFixed,
            current,
            len,
            lenHot,
            lenBank,
            lenInsure,
            lenFund,
            dataHot,
            dataBank,
            dataInsure,
            dataFund,
            hotCount,
            bankCount,
            insureCount,
            fundCount,
        } = this.state;

        return (
            <div className={styles.info}>
                <div id="tabs">
                    <div className={`${styles.tabHead} ${isFixed ? styles.fix : ''}`}>
                        <div
                            className={`${styles.tabHeadItem} ${current === 0 ? styles.current : ''}`}
                            onClick={() => this.handleClick(0)}>
                            热点要闻
                        </div>
                        <div
                            className={`${styles.tabHeadItem} ${current === 1 ? styles.current : ''}`}
                            onClick={() => this.handleClick(1)}>
                            银行
                        </div>
                        <div
                            className={`${styles.tabHeadItem} ${current === 2 ? styles.current : ''}`}
                            onClick={() => this.handleClick(2)}>
                            保险
                        </div>
                        <div
                            className={`${styles.tabHeadItem} ${current === 3 ? styles.current : ''}`}
                            onClick={() => this.handleClick(3)}>
                            基金
                        </div>
                    </div>
                    <div>
                        <div className={current === 0 ? styles.tabBodyItemActive : styles.tabBodyItem}>
                            <div>
                                {this.listView(dataHot, len, hotCount)}
                                {this.moreView(dataHot, lenHot, '1-73-47-')}
                            </div>
                        </div>
                        <div className={current === 1 ? styles.tabBodyItemActive : styles.tabBodyItem}>
                            <div>
                                {this.listView(dataBank, len, bankCount)}
                                {this.moreView(dataBank, lenBank, '1-73-215395-')}
                            </div>
                        </div>
                        <div className={current === 2 ? styles.tabBodyItemActive : styles.tabBodyItem}>
                            <div>
                                {this.listView(dataInsure, len, insureCount)}
                                {this.moreView(dataInsure, lenInsure, '1-73-245402-')}
                            </div>
                        </div>
                        <div className={current === 3 ? styles.tabBodyItemActive : styles.tabBodyItem}>
                            <div>
                                {this.listView(dataFund, len, fundCount)}
                                {this.moreView(dataFund, lenFund, '1-73-245403-')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        // return footer;
    }
}

export default errorBoundary(TabInfo);
